import {
  listaDeMidiasSchema,
  midiaDaBibliotecaSchema,
  type ListaDeMidiasDto,
  type MidiaDaBibliotecaDto,
  type OrigemDeMidia,
  type OrdenacaoDoAcervo,
  type PlataformaDePublicacaoDto,
  type TipoDeArquivoAcervo,
  type TipoDePublicacaoDto,
} from "@base/contracts";
import { z } from "zod";
import type { ClienteHttp } from "../../../shared/http/cliente-http";

export type FiltroListarMidias = {
  readonly tipo?: TipoDePublicacaoDto;
  readonly plataformas?: readonly PlataformaDePublicacaoDto[];
  readonly q?: string;
  readonly tipoArquivo?: TipoDeArquivoAcervo;
  readonly origem?: OrigemDeMidia;
  readonly soFavoritas?: boolean;
  readonly ordenar?: OrdenacaoDoAcervo;
};

export type MidiasGateway = {
  listar(filtro?: FiltroListarMidias): Promise<ListaDeMidiasDto>;
  enviar(arquivos: File[]): Promise<ListaDeMidiasDto>;
  marcarFavorita(id: string, favorita: boolean): Promise<MidiaDaBibliotecaDto>;
  excluir(id: string): Promise<{ ok: true }>;
};

export class MidiasGatewayHttp implements MidiasGateway {
  constructor(private readonly http: ClienteHttp) {}

  listar(filtro?: FiltroListarMidias): Promise<ListaDeMidiasDto> {
    const q = filtro?.q?.trim();
    return this.http.requisitar("/v1/midias", listaDeMidiasSchema, {
      consulta: {
        ...(filtro?.tipo ? { tipo: filtro.tipo } : {}),
        ...(filtro?.plataformas?.length
          ? { plataformas: filtro.plataformas.join(",") }
          : {}),
        ...(q ? { q } : {}),
        ...(filtro?.tipoArquivo ? { tipoArquivo: filtro.tipoArquivo } : {}),
        ...(filtro?.origem ? { origem: filtro.origem } : {}),
        ...(filtro?.soFavoritas ? { favoritas: "1" } : {}),
        ...(filtro?.ordenar ? { ordenar: filtro.ordenar } : {}),
      },
    });
  }

  enviar(arquivos: File[]): Promise<ListaDeMidiasDto> {
    const form = new FormData();
    for (const arquivo of arquivos) form.append("arquivos", arquivo);
    return this.http.requisitarFormData("/v1/midias", listaDeMidiasSchema, form);
  }

  marcarFavorita(id: string, favorita: boolean): Promise<MidiaDaBibliotecaDto> {
    return this.http.requisitar(`/v1/midias/${id}`, midiaDaBibliotecaSchema, {
      metodo: "PATCH",
      corpo: { favorita },
    });
  }

  excluir(id: string): Promise<{ ok: true }> {
    return this.http.requisitar(`/v1/midias/${id}`, z.object({ ok: z.literal(true) }), {
      metodo: "DELETE",
    });
  }
}

export type { MidiaDaBibliotecaDto };
